module.exports = __webpack_public_path__ + "static/img/ma-xcx.3707746.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ma-xcx.jpg
// module id = NzJt
// module chunks = 85